import { SkuFilter } from './sku-filter';
import { SkuRequestFilter } from './sku-request-filter';
import { TotalSKUSizeRange } from './total-sku-size';
import { Frequency } from './types/frequency.type';
import { PricePer } from './types/price-per.type';
import { TimeSeriesData } from './types/time-series-data.type';

export class ExtractionDto {
    constructor(
        public title: string,
        public description: string,
        public searchPhrase: string,
        public frequency: Frequency,
        public timeSeriesData: TimeSeriesData[],
        public skuFilters: SkuRequestFilter,
        public pricePer: PricePer,
        public currency: string,
        public fileType: string,
        public startDate?: Date,
        public endDate?: Date,
        public includeAttributesFile?: boolean
    ) {}
}
